import React from 'react';
import type { LoyaltyPointsIconProps } from '../..';

export const PlatinumMulti = ({ size }: Pick<LoyaltyPointsIconProps, 'size'>) => {
    if (size === 'sm') {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="39" height="20" viewBox="0 0 39 20" fill="none">
                <path
                    d="M28.6447 18.7C33.4495 18.7 37.3446 14.8049 37.3446 10C37.3446 5.19513 33.4495 1.3 28.6447 1.3C23.8398 1.3 19.9448 5.19513 19.9448 10C19.9448 14.8049 23.8398 18.7 28.6447 18.7Z"
                    fill="#B1C9F0"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M19.2575 18.7C24.0623 18.7 27.9574 14.8049 27.9574 10C27.9574 5.19513 24.0623 1.3 19.2575 1.3C14.4526 1.3 10.5576 5.19513 10.5576 10C10.5576 14.8049 14.4526 18.7 19.2575 18.7Z"
                    fill="#8FB0E4"
                    stroke="white"
                    strokeWidth="1.4"
                />
                <path
                    d="M9.93522 18.6353C14.7043 18.6353 18.5704 14.7692 18.5704 10C18.5704 5.23087 14.7043 1.3647 9.93522 1.3647C5.16611 1.3647 1.3 5.23087 1.3 10C1.3 14.7692 5.16611 18.6353 9.93522 18.6353Z"
                    fill="#557CB6"
                    stroke="white"
                    strokeWidth="1.4"
                />
            </svg>
        );
    }

    // Size md
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="28" viewBox="0 0 56 28" fill="none">
            <path
                d="M41.8053 26.8C48.8745 26.8 54.6051 21.0692 54.6051 14C54.6051 6.93076 48.8745 1.2 41.8053 1.2C34.7361 1.2 29.0054 6.93076 29.0054 14C29.0054 21.0692 34.7361 26.8 41.8053 26.8Z"
                fill="url(#paint0_linear_1938_153574)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M27.8055 26.8C34.8747 26.8 40.6054 21.0692 40.6054 14C40.6054 6.93076 34.8747 1.2 27.8055 1.2C20.7363 1.2 15.0057 6.93076 15.0057 14C15.0057 21.0692 20.7363 26.8 27.8055 26.8Z"
                fill="url(#paint1_linear_1938_153574)"
                stroke="white"
                strokeWidth="1.6"
            />
            <path
                d="M13.9028 26.7029C20.9184 26.7029 26.6057 21.0155 26.6057 13.9999C26.6057 6.98425 20.9184 1.29692 13.9028 1.29692C6.88724 1.29692 1.2 6.98425 1.2 13.9999C1.2 21.0155 6.88724 26.7029 13.9028 26.7029Z"
                fill="url(#paint2_linear_1938_153574)"
                stroke="white"
                strokeWidth="1.6"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1938_153574"
                    x1="41.7082"
                    y1="5.96766"
                    x2="41.8053"
                    y2="26"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8CACDF" />
                    <stop offset="1" stopColor="#D1E2FE" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1938_153574"
                    x1="35.1478"
                    y1="26.7978"
                    x2="28.7841"
                    y2="3.75761"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B7CFF3" />
                    <stop offset="1" stopColor="#638FD5" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1938_153574"
                    x1="13.9028"
                    y1="2.09692"
                    x2="13.9028"
                    y2="25.9029"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4972B0" />
                    <stop offset="1" stopColor="#79A3E2" />
                </linearGradient>
            </defs>
        </svg>
    );
};
